import React from 'react'
import "./footermain.css"

 const Footermain = () => {

    return (
      <div>
       <div class="bottom_box">
            <div class="left1_bottom">
                <h4>KEY SERIES</h4>
                
                <div class="series"><a href="">U19-World Cup</a></div>
                <div class="series"><a href="">Woemen's Ashes</a></div>
                <div class="series"><a href="">World Championship</a></div>
                <div class="series"><a href="">World Cup Super League</a></div>
                <div class="series"><a href="">Women's Championship</a></div>
                <div class="series"><a href="">Marsh Cup</a></div>
                <div class="series"><a href="">BBl 2021</a></div>
                <div class="series"><a href="">super Smash</a></div>
                <div class="series"><a href="">Sheffield Shield</a></div>
                <div class="series"><a href="">World Test Championship</a></div>
                <div class="series"><a href="">CWC challenge League A</a></div>
                <div class="series"><a href="">CWC Challenge League B</a></div>
                <div class="series"><a href="">South Africa v Sri Lanka</a></div>
                <div class="series"><a href="">Pakistan v Scotland</a></div>

            </div>
            <div class="left2_bottom">
                <h4>QUICKS LINKS</h4>
               
                <div class="series"><a href="">T20 Timeout</a></div>
                <div class="series"><a href="">Fantasy Pick</a></div>
                <div class="series"><a href="">ICC Rankings</a></div>
            </div>
            <div class="left2_bottom">
                <h4>ESPNcricinfo Apps</h4>
                
                <div class="series"><a href="https://play.google.com/store/apps/details?id=com.july.cricinfo&hl=en">Android App</a></div>
                <div class="series"><a href="https://apps.apple.com/in/app/cricinfo-live-cricket-scores/id417408017">iOs App</a></div>
            </div>
            <div class="left2_bottom">
                <h4>FOLLOW ESPNcricinfo</h4>
                
                <div class="series"><a href="https://www.instagram.com/espncricinfo/">Instagram</a></div>
                <div class="series"><a href="https://twitter.com/espncricinfo">Twitter</a></div>
                <div class="series"><a href="https://www.facebook.com/Cricinfo/">Facebook</a></div>
                <div class="series"><a href="https://www.youtube.com/espncricinfo">youTube</a></div>
            </div>
            <div class="left2_bottom">
                <h4>ESPN Sites</h4>
                
                <div class="series"><a href="http://www.thecricketmonthly.com/">The Cricket Monthly</a></div>
                <div class="series"><a href="http://www.espn.in/">ESPN</a></div>

            </div>

        </div>
      </div>
    )

}
export default Footermain